// extracted by css-extract-rspack-plugin
export default {"markerMenuOverlay":"roadmap-marker-menu-module__markerMenuOverlay__plgmf"};